/* eslint-disable import/no-anonymous-default-export */
import axios from './BASE_API'
import AuthHeader from './AuthHeader'

// class define
class SettingsAPI {
  // update company profile
  getUserList: any = () => {
    return axios.get('/company/user-list', {headers: AuthHeader()})
  }

  getUserById: any = (data: any) => {
    return axios.post('/company/user-profile', data, {headers: AuthHeader()})
  }

  // get permission list
  getPermissionList: any = () => {
    return axios.get('/permission/activeList', {headers: AuthHeader()})
  }

  addCompanyUser: any = (data: any) => {
    return axios.post('/company/add-company-user', data, {headers: AuthHeader()})
  }
  getPendingUser: any = () => {
    return axios.get('/company/pending-user', {headers: AuthHeader()})
  }
  resendInvite: any = (data: any) => {
    return axios.post('/company/resend-invite', data, {headers: AuthHeader()})
  }
  sendSMSRequest: any = (data: any) => {
    return axios.post('/company-sms/request', data, {headers: AuthHeader()})
  }
  revokeInvite: any = (data: any) => {
    return axios.post('/company/revoke-invite', data, {headers: AuthHeader()})
  }
  deleteUser: any = (id: number) => {
    return axios.delete(`/company/delete-company-user`, {
      data: {
        id: id as number,
      },
      headers: AuthHeader(),
    })
  }
  acceptInvite: any = (data: any) => {
    return axios.post('/company/accept-invite', data)
  }

  updateConfigurationAPI = (data: any) => {
    return axios.patch('/configuration/update', data, {headers: AuthHeader()})
  }

  detailsConfigurationAPI = () => {
    return axios.get('/configuration/details', {headers: AuthHeader()})
  }

  templatePost: any = (data: any) => {
    return axios.put('/company-template/update', data, {headers: AuthHeader()})
  }

  deleteTemplate: any = (id: number) => {
    return axios.delete(`/company-template/delete`, {
      data: {
        id: id as number,
      },
      headers: AuthHeader(),
    })
  }
}

export default new SettingsAPI()
